import { ICourseCatalogCategoryQuery } from '../interfaces/course-catalog-category.query.interface';

// @dynamic
export class CourseCatalogCategory {
    id: string;
    name: string;
    type: string;
    sequence: number;
    parent?: {
        id: string;
    };

    constructor(query?: ICourseCatalogCategoryQuery) {
        if (query) {
            this.id = query.id?.toString();
            this.name = query.name;
            this.type = query.type;
            this.sequence = query.sequence;
            this.parent = query.parent
                ? {
                      id: String(query.parent.id),
                  }
                : null;
        }
    }
}
